import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { Link } from "react-router-dom";
import AboutHeader from "../../components/aboutHeader/aboutHeader";
import Footer from "../../components/footer/footer";
import { auth } from "../../db/config";

export default function About() {
  const [user, setuser] = useState(false);
  useEffect(() => {
    auth.onAuthStateChanged((user) => {
      if (user.uid) {
        setuser(true);
      } else {
        setuser(false);
      }
    });
  }, []);
  return (
    <div>
      <AboutHeader />
      <div class="page_title_section">
        <div class="page_header">
          <div class="container">
            <div class="row">
              <div class="col-lg-9 col-md-9 col-12 col-sm-8">
                <h1>About us </h1>
              </div>
              <div class="col-lg-3 col-md-3 col-12 col-sm-4">
                <div class="sub_title_section">
                  <ul class="sub_title">
                    <li>
                      {" "}
                      <a href="/"> Home </a>&nbsp; / &nbsp;{" "}
                    </li>
                    <li>About us </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="sv_about_wrapper fixed_portion float_left">
        <div class="container">
          <div class="row">
            <div class="col-lg-12 col-md-12 col-12 col-sm-12">
              <div class="border_about_wrapper float_left">
                <div class="row">
                  <div class="col-lg-6 col-md-12 col-12 col-sm-12">
                    <div class="sv_abt_img_wrapper float_left">
                      <img
                        src="images/abt_img.jpg"
                        alt="img"
                        class="img-responsive"
                      />
                    </div>
                  </div>
                  <div class="col-lg-6 col-md-12 col-12 col-sm-12">
                    <div class="sv_abt_content_wrapper float_left">
                      <h1>OUR STORY</h1>
                      <p>
                        One of the best investing marketing
                        <br /> tools is High yield investment program.
                      </p>
                    </div>
                    <p>
                      Welcome to the website of treasuregrowthinvestment.com! If
                      you find yourself here, you are definitely in search of
                      reliable and profitable investment. Yes, you are just at
                      the right place! Our company offers trust assets
                      management of the highest quality on the basis of foreign
                      exchange and profitable trade through Funds exchanges.
                      <br />
                      <br /> worldwide financial market that can guarantee a
                      daily ability to generate constant profit with the large
                      price swings of BitCoin and other crypto currencies.
                      Proposed modalities for strengthening cooperation will be
                      accepted by anyone who uses cryptocurrency and knows about
                      its fantastic prospects.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="sv_money_wrapper float_left">
        <div class="container">
          <div class="row">
            <div class="col-lg-6 col-md-12 col-12 col-sm-12">
              <div class="sv_money_text_wrapper float_left">
                <h1>We Make Your</h1>
                <h2>
                  Invest To Grow a <br />
                  Your Money !
                </h2>
                <p>
                  Treasure growth investment is a product of careful preparation
                  and fruitful work of experts in the field of mining, highly
                  profitable trade in cryptocurrencies and online marketing.
                  Using modern methods of doing business and a personal approach
                  to each client, we offer a unique investment model to people
                  who want to use cryptocurrencies not only as a method of
                  payment, but also as a reliable source of stable income. Your
                  deposit is working on an ongoing basis, and makes profit with
                  the ability to withdraw profit. Your deposit is for life and
                  irretrievable. This proposal would be interesting not only for
                  beginners of cryptocurrency operation, but also for
                  experienced online investors. Treasure growth investment
                  Business uses only modern mining equipment and trades at the
                  most stable markets, which minimizes the risk of financial
                  loss to customers and guarantees them a stable income accrued
                  every 60 minutes. Join our company today and start making high
                  profits!
                </p>
                <div class="about_btn float_left inner_abt_btn">
                  <ul>
                    {user ? (
                      ""
                    ) : (
                      <li>
                        <a href="/register">get Started</a>
                      </li>
                    )}
                  </ul>
                </div>
              </div>
            </div>
            <div class="col-lg-6 col-md-12 col-12 col-sm-12">
              <div class="sv_abt_img_wrapper float_left">
                <img src="images/abt_1.png" alt="img" class="img-responsive" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="counter_section float_left">
        <div class="investment_overlay"></div>
        <div class="counter-section2">
          <div class="container">
            <div class="row">
              <div class="col-lg-3 col-md-3 col-12 col-sm-6">
                <div class="counter_cntnt_box">
                  <div class="tb_icon investment_icon_circle">
                    <div class="icon">
                      <i class="flaticon-bar-chart"></i>
                    </div>
                    <div class="investment_border_wrapper"></div>
                  </div>
                  <div class="count-description">
                    <span class="timer">2846</span>
                    <h5 class="con1">
                      {" "}
                      <a href="#">days online</a>
                    </h5>
                  </div>
                </div>
              </div>
              <div class="col-lg-3 col-md-3 col-12 col-sm-6">
                <div class="counter_cntnt_box">
                  <div class="tb_icon investment_icon_circle blue_icon_circle">
                    <div class="icon">
                      <i class="flaticon-user"></i>
                    </div>
                    <div class="investment_border_wrapper blue_border_wrapper"></div>
                  </div>
                  <div class="count-description">
                    {" "}
                    <span class="timer">425</span>
                    <h5 class="con2">
                      {" "}
                      <a href="#"> registered users </a>
                    </h5>
                  </div>
                </div>
              </div>
              <div class="col-lg-3 col-md-3 col-12 col-sm-6">
                <div class="counter_cntnt_box">
                  <div class="tb_icon investment_icon_circle red_info_circle">
                    <div class="icon">
                      <i class="flaticon-salary"></i>
                    </div>
                    <div class="investment_border_wrapper red_border_wrapper"></div>
                  </div>
                  <div class="count-description">
                    {" "}
                    <span class="timer">7660</span>
                    <h5 class="con2">
                      {" "}
                      <a href="#"> total deposit </a>
                    </h5>
                  </div>
                </div>
              </div>
              <div class="col-lg-3 col-md-3 col-12 col-sm-6">
                <div class="counter_cntnt_box">
                  <div class="tb_icon investment_icon_circle green_info_circle">
                    <div class="icon">
                      <i class="flaticon-withdrawal"></i>
                    </div>
                    <div class="investment_border_wrapper green_border_wrapper"></div>
                  </div>
                  <div class="count-description">
                    {" "}
                    <span class="timer">2347</span>
                    <h5 class="con4">
                      {" "}
                      <a href="#"> total withdraw</a>
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
